import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from 'app/styles/content';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
const Kickoff = styled(FlexContainer).withConfig({
  componentId: "sc-1wypky0-0"
})(["align-self:center;flex-direction:column;justify-content:center;align-items:center;width:", ";height:", ";"], SIZES['56'], SIZES['30']);
const MatchStatus = styled(Typography).withConfig({
  componentId: "sc-1wypky0-1"
})(["&&&{line-height:1.4;color:", ";}"], COLORS.black);
const LiveTypography = styled(Typography).withConfig({
  componentId: "sc-1wypky0-2"
})(["&&&{line-height:1.25;}"]);
export default function MatchRowTeaserKickoff(_ref) {
  let {
    kickoff,
    live
  } = _ref;
  return /*#__PURE__*/React.createElement(Kickoff, {
    "data-sentry-element": "Kickoff",
    "data-sentry-component": "MatchRowTeaserKickoff",
    "data-sentry-source-file": "MatchRowTeaserKickoff.tsx"
  }, /*#__PURE__*/React.createElement(MatchStatus, {
    variant: "caption3",
    "data-sentry-element": "MatchStatus",
    "data-sentry-source-file": "MatchRowTeaserKickoff.tsx"
  }, kickoff), live ? /*#__PURE__*/React.createElement(LiveTypography, {
    variant: "caption1"
  }, "live") : null);
}